<template>
  <div class="py-5 mt-4">
    <div>
      <h2 class="titlePage font-weight-bold text-capitalize mb-1 h2">
        {{ $t('settings.twoWay.title') }}
      </h2>
    </div>
    <div style="min-height: 48px" class="mb-1">
      <transition name="fade" style="min-height: 30px">
        <MenssageAlert :messages="messages" />
      </transition>
    </div>
    <LoadingSpinner v-if="loadingConfig" size="sm" />
    <div v-if="showUnextingModal && !isSenditUser">
      <CCard>
        <CCardBody>
          <h5 class="pb-3">{{ $t('settings.twoWay.unexisting.modal.title') }}</h5>
          <div class="">{{ $t('settings.twoWay.unexisting.modal.subtitle') }}</div>
          <a
            class="contact-now"
            href="https://webforms.pipedrive.com/f/1uLi7WT7rXzSFLaUS0Qjk5gger59kwnssFb5JKXI99kcYR9JsphAvykpU1cp6Lf3R"
            target="_blank"
          >
            {{ $t('settings.twoWay.unexisting.modal.contact-now') }}
          </a>
        </CCardBody>
      </CCard>
    </div>
    <CCard v-if="!loadingConfig && isSenditUser" class="pb-3">
      <CCardHeader class="font-weight-bolder"> {{ $t('settings.twoWay.card.header') }} </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol class="col-auto">
            <CSwitch
              color="primary"
              variant="3d"
              size="sm"
              :checked="organizationTwoWayStatus"
              @update:checked="changeOrganizationTwoWayStatus"
              :disabled="loading"
            />
          </CCol>
          <CCol>
            <div class="font-weight-bolder">
              {{ $t('settings.twoWay.switch.label') }}
            </div>
            <div>{{ $t('settings.twoWay.switch.subtitle') }}</div>
          </CCol>
        </CRow>

        <div v-if="organizationTwoWayStatus" class="text-right mt-5">
          <CButton color="primary" class="px-5 py-2" :disabled="loading" @click="goToNewConfiguration()">{{
            $t('settings.twoWay.button.configure')
          }}</CButton>
        </div>
      </CCardBody>
    </CCard>

    <ConfigartionListNumbers v-if="!loadingConfig && statusText != 'UNEXISTING'" class="mt-4" />

    <CModal :show.sync="showConfirmationModal" :closeOnBackdrop="false">
      <template #header-wrapper>
        <h5 class="pt-5 pb-2">{{ $t('settings.twoWay.confirmation.modal.title') }}</h5>
      </template>
      <template #body-wrapper>
        <div class="text-gray-400">{{ $t('settings.twoWay.confirmation.modal.subtitle') }}</div>
      </template>
      <template #footer-wrapper>
        <div class="mt-5 text-right">
          <CButton color="white" class="px-4 mr-2" :disabled="loading" @click="closeConfirmationModal()">{{
            $t('settings.twoWay.confirmation.modal.button.no')
          }}</CButton>
          <CButton color="primary" class="px-4" :disabled="loading" @click="setOrganizationTwoWayStatus(true)">{{
            $t('settings.twoWay.confirmation.modal.button.yes')
          }}</CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>
<script>
import services from '@/services.js'
import LoadingSpinner from '@/components/LoadingSpinner'
import MenssageAlert from '@/components/MenssageAlert'
import { PLAN_TYPES } from '@/views/plansSubscriptions/constants'
import ConfigartionListNumbers from '../components/ConfigartionListNumbers.vue'

const OrganizationInboundSmsConfigStateEnum = {
  UNEXISTING: 1,
  ENABLED: 2,
  DISABLED: 3,
}

export default {
  name: 'TwoWayConfiguration',
  components: {
    LoadingSpinner,
    MenssageAlert,
    ConfigartionListNumbers,
  },
  data() {
    return {
      messages: [],
      loadingConfig: false,
      loading: false,
      statusText: '',
      organizationTwoWayStatus: false,
      organizationTwoWayStatusInitial: false,
      showConfirmationModal: false,
      showUnextingModal: false,
    }
  },
  computed: {
    isSenditUser() {
      return this.$store.getters['auth/isSendit']
    },
  },
  mounted() {
    if (this.$store.state.auth.session.organization.planType != PLAN_TYPES.CORPORATE) {
      this.showUnextingModal = true
      this.statusText = 'UNEXISTING'
      return
    }

    this.getTwoWayConfig()
  },

  methods: {
    goToNewConfiguration() {
      this.$router.push({ name: 'new-two-way-configuration' })
    },
    getTwoWayConfig() {
      this.loadingConfig = true

      const organizationId = this.$route.params.organizationId

      services
        .getTwoWayConfig(organizationId)
        .then((res) => {
          let result = res.data.data.status
          this.statusText = result
          this.organizationTwoWayStatusInitial = this.organizationTwoWayStatus =
            OrganizationInboundSmsConfigStateEnum[this.statusText] == 2 ? true : false
          this.showUnextingModal = OrganizationInboundSmsConfigStateEnum[this.statusText] == 1 // Exibe modal em caso de configuração não existente
        })
        .catch()
        .finally(() => (this.loadingConfig = false))
    },

    changeOrganizationTwoWayStatus(value) {
      this.organizationTwoWayStatus = value
      this.setOrganizationTwoWayStatus()
    },

    closeConfirmationModal() {
      this.organizationTwoWayStatus = this.organizationTwoWayStatusInitial
      this.showConfirmationModal = false
    },

    setOrganizationTwoWayStatus(verified = false) {
      // Regra que mostra o modal de confirmação caso seja uma desativação
      if (!this.organizationTwoWayStatus && !verified) {
        this.showConfirmationModal = true
        return
      }

      this.loading = true

      const organizationId = this.$route.params.organizationId
      const body = {
        isActive: this.organizationTwoWayStatus,
      }
      this.messages = []
      services
        .setTwoWayConfig(organizationId, body)
        .then(() => {
          this.organizationTwoWayStatusInitial = this.organizationTwoWayStatus
          this.messages.push({
            status: 'success',
            text: this.$t('settings.twoWay.configuration.success'),
          })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
          this.showConfirmationModal = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.contact-now {
  font-weight: bold;
  text-decoration: underline !important;
  color: var(--primary);

  &:hover {
    color: var(--purple-200);
  }
}
</style>

<style>
.c-switch[class*='-3d'].c-switch-sm .c-switch-input:checked ~ .c-switch-slider::before {
  -webkit-transform: translateX(30px);
  transform: translateX(30px);
}

.c-switch[class*='-3d'].c-switch-sm {
  width: 50px;
}
</style>
